import { combineReducers } from "redux";
import login from "./login";
import SubScheme from "./SubScheme";
import showroom from "./showroom";
import ReportPage from "./ReportPage";
import delectionsearch from "./delectionsearch";
import schememobile from "./schememobile";
import masterSchemeID  from "./masterscheme";
import userLevelMobile from "./userLevelMobile";
import reportNavigation  from "./ReportNavigation";
import AppicationInboxCount from "./applicationInbox";

export const reducers = combineReducers({
  login,
  SubScheme,
  showroom,
  ReportPage,
  delectionsearch,
  schememobile,
  masterSchemeID,
  userLevelMobile,
  reportNavigation,
  AppicationInboxCount,
});
